import renderPage         from '../components/render_page';
import ServiceMonsterPage from './servicemonster_page';


export default {
  path:       '/integration/servicemonster',
  noBusiness: true,
  component:  renderPage(ServiceMonsterPage)
};
